import ReactDOM from 'react-dom'
import cx from 'classnames'

import ImageLoader from 'components/ImageLoader'

import './style.scss'

const LightBox = ({
  isActive = false,
  onClose = () => {},
  url = null,
  type = 'image',
}: {
  isActive: boolean
  onClose: any
  url: string
  type?: 'image' | 'video'
}) => {
  return ReactDOM.createPortal(
    <div
      className={cx('LightBox', {
        'LightBox--active': isActive,
      })}
    >
      <a className="LightBox__overlay" onClick={onClose} />
      <a className="LightBox__close" onClick={onClose}>
        <img src="/images/icon-close-circle-black.svg" />
      </a>

      <div className="LightBox__wrapper">
        {type === 'image' && <ImageLoader url={url} alt={url} />}
        {type === 'video' && (
          <video preload="none" autoPlay={true} muted controls>
            <source src={url} />
          </video>
        )}
      </div>
    </div>,
    document.querySelector('#lightBoxes')
  )
}

export default LightBox
